module.exports = __webpack_public_path__ + "img/icon_expired.11ac3155.png";